import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { map } from "rxjs/operators";
import { GLOBAL } from "./global";

@Injectable({
  providedIn: "root",
})
export class ProcessingpService {
  private url: string;
  private urlManifest: string;
  private main_url: string;

  constructor(private http: HttpClient) {
    this.url = GLOBAL.url + "/cita/processing/";
    this.urlManifest = GLOBAL.url + "/manifestitem/";
    this.main_url = GLOBAL.url;
  }

  getItemsAvailablesByFather(
    token: string,
    id: any,
    hideprocessed = 0
  ): Observable<any> {
    const task = {
      onlyprocessed: hideprocessed,
    };
    const params = `json=${encodeURIComponent(
      JSON.stringify(task)
    )}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/manifestitem/listavailablesbyfather/${id}?page=1`,
      params,
      { headers }
    );
  }

  
  changeweightManifest(token: string, id: any, task: any): Observable<any> {
    const params = `json=${encodeURIComponent(
      JSON.stringify(task)
    )}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/manifestitem/changeweight/${id}?page=1`,
      params,
      { headers }
    );
  }

  changeLocationManifest(token: string, id: any, task: any): Observable<any> {
    const params = `json=${encodeURIComponent(
      JSON.stringify(task)
    )}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/manifestitem/changeLocation/${id}?page=1`,
      params,
      { headers }
    );
  }

  changeLocationManifestBulk(token: string, task: any): Observable<any> {
    const params = `json=${encodeURIComponent(
      JSON.stringify(task)
    )}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/manifestitem/changelocationbulk`,
      params,
      { headers }
    );
  }

  changeLocationScrapBulk(token: string, task: any): Observable<any> {
    const params = `json=${encodeURIComponent(
      JSON.stringify(task)
    )}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/scrapitem/changelocationbulk`,
      params,
      { headers }
    );
  }

  asign(token: string, pi_id: any, url: string, rep_id = ""): Observable<any> {
    let params;
    if (rep_id !== null) {
      const json = { rep_id: rep_id };
      params = `json=${encodeURIComponent(
        JSON.stringify(json)
      )}&authorization=${token}`;
    } else {
      params = `authorization=${token}`;
    }
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/${url}/${pi_id}?page=1`, params, {
      headers,
    });
  }

  reportes(po: any, token: string): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/report/detailallbypo/${po}?page=1`,
      params,
      { headers }
    );
  }

  create(token: string, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/new?page=1`, params, { headers });
  }

  update(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/editar/${id}?page=1`, params, {
      headers,
    });
  }

  getstage(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/getstage/${id}?page=1`, params, {
      headers,
    });
  }

  editar(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/edit/${id}?page=1`, params, {
      headers,
    });
  }

  search(token: string, task: any, page: any, perPage: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/po/search?page=${page}&perpage=${perPage}`,
      params,
      { headers }
    );
  }

  changestatus(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/changestatus/${id}?page=1`, params, {
      headers,
    });
  }

  settestingstatus(token: string, id: any, task: any): Observable<any> {
     const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;

    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/cita/processing/settestingstatus/${id}?page=1`,
      params,
      { headers }
    );
  }


  undomanifest(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/cita/processing/undomanifest/${id}?page=1`,
      params,
      { headers }
    );
  }

  markmanifeststatusprocessed(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/cita/processing/markmanifeststatusprocessed/${id}?page=1`,
      params,
      { headers }
    );
  }

  markpoprocessed(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/cita/processing/markpoprocessed/${id}?page=1`,
      params,
      { headers }
    );
  }

  markaspaid(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/markaspaid/${id}?page=1`, params, {
      headers,
    });
  }

  marktestingComplete(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/cita/processing/marktestingstatusprocessed/${id}?page=1`,
      params,
      { headers }
    );
  }

  setmanifestdone(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}setdone/${id}?page=1`,
      params,
      { headers }
    );
  }

  setContainersDone(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}containersdone/${id}?page=1`,
      params,
      { headers }
    );
  }

  weights(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.main_url}/cita/weights/${id}?page=1`,
      params,
      { headers }
    );
  }

  getOne(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/detail/${id}?page=1`, params, {
      headers,
    });
  }

  getAll(
    token: string,
    page: any,
    status: string,
    perPage: any,
    busqueda: string,
    type: string,
    manifestStatus: string,
    sort = "",
    sortby = "",
    estatus = "",
    filtros = [],
    task:any
  ): Observable<any> {
/*     const task = {
      q: busqueda,
      status: estatus,
    }; */
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let url = "";

    if (status === "MANIFESTREQUIRED") {
      if (manifestStatus === "ALL") {
        url = `${this.main_url}/cita/manifest/list/${type}?page=${page}&perpage=${perPage}`;
      } else {
        url = `${this.main_url}/cita/manifest/list/${type}/${manifestStatus}?page=${page}&perpage=${perPage}`;
      }
    } else if (busqueda !== "" && busqueda !== null) {
      url = `${this.main_url}/po/search?page=${page}&perpage=${perPage}`;
    } else {
      url = `${this.main_url}/cita/processing/list/${status}?page=${page}&perpage=${perPage}`;
    }

    if (sortby) {
      if (sort === "") {
        sort = "DESC";
      }
      url = `${url}&order=${sort}&orderby=${filtros[sortby].key}`;
    }

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url = `${url}&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url = `${url}&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this.http.post<any>(url, params, { headers });
  }

  getAllOpti(
    token: string,
    page: any,
    status: string,
    perPage: any,
    busqueda: string,
    type: string,
    manifestStatus: string,
    sort = "",
    sortby = "",
    estatus = "",
    filtros = [],
    task:any
  ): Observable<any> {
/*     const task = {
      q: busqueda,
      status: estatus,
    }; */
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let url = "";

    if (status === "MANIFESTREQUIRED") {
      if (manifestStatus === "ALL") {
        url = `${this.main_url}/cita/manifest/list/${type}?page=${page}&perpage=${perPage}`;
      } else {
        url = `${this.main_url}/cita/manifest/list/${type}/${manifestStatus}?page=${page}&perpage=${perPage}`;
      }
    } else if (busqueda !== "" && busqueda !== null) {
      url = `${this.main_url}/po/search?page=${page}&perpage=${perPage}`;
    } else {
      url = `${this.main_url}/cita/processing/list/${status}?page=${page}&perpage=${perPage}`;
    }

    if (sortby) {
      if (sort === "") {
        sort = "DESC";
      }
      url = `${url}&order=${sort}&orderby=${filtros[sortby].key}`;
    }

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url = `${url}&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url = `${url}&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this.http.post<any>(url, params, { headers });
  }

  sync(): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.get<any>(
      "https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-po.php",
      { headers }
    );
  }

  syncInventory(po: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.get<any>(
      `https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-inventory-items.php?po=${po}`,
      { headers }
    );
  }

  syncInventoryPoLine(poline: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.get<any>(
      `https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-po-inventory-all.php?poid=${poline}`,
      { headers }
    );
  }

  syncLenovo(po: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.get<any>(
      `https://www.itaderp.com/backend/reports/bot-workflow-lenovo-match.php?po=${po}`,
      { headers }
    );
  }

  syncInventoryMass(po: string): Observable<any> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.get<any>(
      `https://www.itaderp.com/backend/bot-extraer-pos/bot-extract-inventory-items-mass.php?po=${po}`,
      { headers }
    );
  }

  delete(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/remove/${id}?page=1`, params, {
      headers,
    });
  }

  newItemManifest(token: string, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.urlManifest}new?page=1`, params, {
      headers,
    });
  }

  newItemSplitManifest(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}newsplit/${id}?page=1`,
      params,
      { headers }
    );
  }

  changestatusmanifest(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}changestatus/${id}?page=1`,
      params,
      { headers }
    );
  }

  resumenManifest(token: string, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${json}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.urlManifest}resume?page=1`, params, {
      headers,
    });
  }

  listItemsManifest(
    token: string,
    page: any,
    perPage: any,
    busqueda = "",
    filtros = [],
    status = ""
  ): Observable<any> {
    const json = JSON.stringify(status);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let url = `${this.urlManifest}list?page=${page}&perpage=${perPage}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url = `${url}&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url = `${url}&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this.http.post<any>(url, params, { headers });
  }

  listGetItemsManifestUserLog(
    token: string,
    userId: string,
    page: any,
    perPage: any,
    filtros = [],
    status = ""
  ): Observable<any> {

    const json = JSON.stringify(status);
    const params = `authorization=${token}&iduser=${userId}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let url = `${this.urlManifest}list_batches?page=${page}&perpage=${perPage}`;

    for (const filtro of filtros) {
      if (filtro && filtro.value) {
        url = `${url}&${filtro.key}=${filtro.value}`;

        if (filtro.type) {
          url = `${url}&${filtro.key_type}=${filtro.type}`;
        }
      }
    }

    return this.http.post<any>(url, params, { headers });

  }

  manifestItemPriority(
    token: any,
    page: any,
    perPage: any,
    listPo: any,
    iduser: string = "",
    type: string = "",
  ){

    const json = JSON.stringify(status);
    const params = `authorization=${token}&iduser=${iduser}&filter_po_priority=${listPo}&action=${type}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let url = `${this.urlManifest}manifest_priority?page=${page}&perpage=${perPage}`;

    return this.http.post<any>(url, params, { headers });
  }

  userBatches(
    token: string,
    userId: string,
  ): Observable<any>{
   // const json = JSON.stringify(status);
    const params = `authorization=${token}&iduser=${userId}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    let url = `${this.urlManifest}user_batches`;
    return this.http.post<any>(url, params, { headers });

  }

  getItemsManifest(
    token: string,
    processing_id: any,
    page = 1,
    perpage = 1000,
    filtromi = "ALL"
  ): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}listbyfather/${processing_id}?page=${page}&perpage=${perpage}&filter_status=${filtromi}`,
      params,
      { headers }
    );
  }

  getItemsManifestTotalResume(
    token: string,
    processing_id: any,
    page = 1,
    perpage = 1000,
    filtromi = "ALL"
  ): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}listbyfathertotalresume/${processing_id}?page=${page}&perpage=${perpage}&filter_status=${filtromi}`,
      params,
      { headers }
    );
  }




  getListPILite(token: string): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/list_lite`, params, {
      headers,
    });
  }

  getSingleManifest(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}detail/${id}?page=1`,
      params,
      { headers }
    );
  }

  editItemManifest(token: string, id: any, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.urlManifest}edit/${id}?page=1`, params, {
      headers,
    });
  }

  removeItemManifest(token: string, id: any): Observable<any> {
    const params = `authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(
      `${this.urlManifest}remove/${id}?page=1`,
      params,
      { headers }
    );
  }

  recived(token: string, id: any, status: any): Observable<any> {
    const task = {
      received: status,
    };
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/setreceived/${id}?page=1`, params, {
      headers,
    });
  }

  updateStatus(token: string, id: any, status: any): Observable<any> {
    const task = {
      status: status,
    };
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/changestatus/${id}?page=1`, params, {
      headers,
    });
  }

  searchByDate(token: string, task: any): Observable<any> {
    const json = JSON.stringify(task);
    const params = `json=${encodeURIComponent(json)}&authorization=${token}`;
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      "X-Requested-With": "XMLHttpRequest",
    });

    return this.http.post<any>(`${this.main_url}/cita/processing/searchbydate?page=1`, params, {
      headers,
    });
  }
}
